(function () {
  const grid = document.getElementById('WishlistGrid');
  const emptyState = document.getElementById('WishlistEmpty');
  const loading = document.getElementById('WishlistLoading');
  if (!grid) return;

  const removeIconMarkup = document.getElementById('WishlistRemoveIconTemplate')?.innerHTML || '';

  function formatMoney(cents) {
    const format = window.wishlistMoneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format.replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  function buildCard(product) {
    const handle = product.handle;
    const variant = product.variants.find((v) => v.available) || product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]) || '';

    const item = document.createElement('div');
    item.className = 'wishlist-page__item';
    item.dataset.productHandle = handle;

    item.innerHTML = `
      <button type="button" class="wishlist-page__remove" aria-label="${window.wishlistStrings.remove}">
        ${removeIconMarkup}
      </button>
      <a href="${product.url}" class="wishlist-page__media">
        ${image ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="533" height="533">` : ''}
      </a>
      <h3 class="wishlist-page__title">
        <a href="${product.url}" class="full-unstyled-link">${escapeHtml(product.title)}</a>
      </h3>
      <div class="wishlist-page__price">${formatMoney(product.price)}</div>
      <button
        type="button"
        class="wishlist-page__add button button--secondary"
        data-variant-id="${variant ? variant.id : ''}"
        ${!variant || !variant.available ? 'disabled' : ''}
      >
        <span>${!variant || !variant.available ? window.wishlistStrings.soldOut : window.wishlistStrings.addToCart}</span>
      </button>
    `;

    item.querySelector('.wishlist-page__remove').addEventListener('click', () => {
      window.SoleWishlist.remove(handle);
      item.remove();
      if (window.SoleWishlist.count() === 0) renderEmptyState();
    });

    const addButton = item.querySelector('.wishlist-page__add');
    addButton.addEventListener('click', () => addToCart(variant.id, addButton));

    return item;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function addToCart(variantId, button) {
    if (!variantId) return;
    const span = button.querySelector('span');
    const originalText = span.textContent;
    button.setAttribute('disabled', 'disabled');
    span.textContent = window.wishlistStrings.adding;

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({ id: variantId, quantity: 1 });

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          span.textContent = window.wishlistStrings.error;
          return;
        }
        span.textContent = window.wishlistStrings.added;
        refreshCartBubble();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist-page', cartData: response });
        }
        setTimeout(() => {
          span.textContent = originalText;
          button.removeAttribute('disabled');
        }, 1500);
      })
      .catch(() => {
        span.textContent = window.wishlistStrings.error;
        button.removeAttribute('disabled');
      });
  }

  function refreshCartBubble() {
    fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = html;
      })
      .catch(() => {});
  }

  function renderEmptyState() {
    grid.hidden = true;
    if (emptyState) emptyState.hidden = false;
  }

  function renderGrid() {
    const handles = window.SoleWishlist.all();

    if (handles.length === 0) {
      if (loading) loading.hidden = true;
      renderEmptyState();
      return;
    }

    Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      if (loading) loading.hidden = true;
      grid.innerHTML = '';

      const validProducts = products.filter(Boolean);

      if (validProducts.length === 0) {
        renderEmptyState();
        return;
      }

      grid.hidden = false;
      if (emptyState) emptyState.hidden = true;
      validProducts.forEach((product) => grid.appendChild(buildCard(product)));
    });
  }

  renderGrid();
  document.addEventListener('wishlist:change', renderGrid);
})();
